import React from "react";
import { Routes, Route } from "react-router-dom";
import IdpMedicine from "../pages/idp-medicine";
import NotFound from "../pages/notFound";
import IdpUgPage from "../pages/idp-ug-pg";
import IdpPgPage from "../pages/idp-ug-pg/idpPg"
import IdpSchool from "../pages/idp-school"
import IdpStudyAbroad from "../pages/idp-studyabroad"
import IdpVirtualFair from "../pages/idp-vertual-fair"

const IdpRoutes = () => {
  const ROUTES = [
    { path: "/idp/user/study-abroad-preference-step1", exact: true, element: <IdpStudyAbroad /> },
    { path: "/idp/medical-user-preference-step1", exact: true, element: <IdpMedicine /> },
    { path: "/idp/user/user-preference", exact: true, element: <IdpUgPage/> },
    { path: "/idp/management/user/user-preference", exact: true, element: <IdpPgPage /> },
    { path: "/idp/school/user/user-preference", exact: true, element: <IdpSchool /> },
    { path: "/idp/virtual-fair-user-preference", exact: true, element: <IdpVirtualFair /> },
    { path: "*", exact: false, element: <NotFound /> },
  ];
  return (
    <>
      <Routes>
        {ROUTES.map((obj, index) => {
          return (
            <Route
              key={index}
              path={obj.path}
              exact={obj.exact}
              element={obj.element}
            />
          );
        })}
      </Routes>
    </>
  );
};
export default IdpRoutes;
